<template>
  <div class="loginContainer">
    <dean-header :logo="headerLogo" logo-height="35"></dean-header>
    <dean-load-overlay></dean-load-overlay>
  </div>
</template>

<script lang="ts">
  import { Vue, Component } from 'vue-property-decorator';
  import { deanLoadOverlay, deanHeader } from '@deanone/dean-components';
  import { exchangeCodeForToken, redirectToKeycloak, startKeepAlive } from '@/services/keycloak';

  @Component({
    components: {
      deanLoadOverlay,
      deanHeader,
    },
  })
  export default class AuthCallback extends Vue {
    get headerLogo() {
      return this.$store.getters.getTheme.data.loginLogo;
    }

    public async created() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');

      if (!code || !state) {
        this.$router.push({ name: 'auth.login' });
        return;
      }

      try {
        const success = await exchangeCodeForToken(code, state);
        if (success) {
          startKeepAlive();
          await this.$store.dispatch('fetchLoggedInUser');
          const intendedEmail = sessionStorage.getItem('login_hint_email');
          const loggedInEmail = this.$store.getters.getUser?.email;
          sessionStorage.removeItem('login_hint_email');
          if (intendedEmail && loggedInEmail && intendedEmail.toLowerCase() !== loggedInEmail.toLowerCase()) {
            redirectToKeycloak(intendedEmail, true);
            return;
          }
          this.$toast({
            text: this.$t('messages.loginSuccess') as string,
            theme: 'success',
          });
          const redirectPath = sessionStorage.getItem('redirect_after_login');
          sessionStorage.removeItem('redirect_after_login');
          if (redirectPath && redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
            this.$router.push(redirectPath);
          } else {
            this.$router.push({ name: 'dashboard' });
          }
        } else {
          this.$router.push({ name: 'auth.login' });
        }
      } catch {
        this.$router.push({ name: 'auth.login' });
      }
    }
  }
</script>
